import LegalLayout from "./LegalLayout";
import ComingSoon from "./ComingSoon";

export default function Contact() {
  return (
    <LegalLayout title="Contact" kicker="Get in touch">
      <ComingSoon
        blurb="We're setting up our support channels. Contact details will be published here shortly."
        testid="legal-contact-coming-soon"
      />
    </LegalLayout>
  );
}
